// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "react-responsive-modal";
import { Button } from "@revvsales/components";

// Components Imports

class EmptyStripePaymentPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _closePopup = () => {
    this.props.toggleModalPopUp("showEmptyStripePaymentPopup", false);
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div className="modal-heading" data-test="emptysigner-modal-heading">
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />{" "}
            You have not added Payment buttons
          </div>

          <div>
            Please ensure that document has Payment buttons. Document recipients
            will click this button to make payments.
          </div>

          <div className="emptysigner-popup-title">To collect payments,</div>

          <div className="emptysigner-popup-content-section">
            <ol>
              <li className="emptysigner-popup-info-list">
                Add a Payment button block on the document
              </li>
              <li className="emptysigner-popup-info-list">
                Integrate with Stripe
              </li>
              <li className="emptysigner-popup-info-list">
                Enter amount to be paid
              </li>
              <li className="emptysigner-popup-info-list">
                Click Send for payment
              </li>
            </ol>
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              id="emapty-signer-back-btn"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="emptysigner-back-btn"
              onClick={this._closePopup}>
              Back to document
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EmptyStripePaymentPopup;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/EmptyStripePaymentPopup.js